"use client";

import { useEffect, useState } from "react";

export default function useIsMobile(): [boolean] {
	const [isMobile, setIsMobile] = useState<boolean>(false);

	useEffect(() => {
		setIsMobile(window.innerWidth < 1200);
	}, []);

	return [isMobile];
}
